/**
 * Get hash string for routing
 * @param {Object} keys - date, view, searchQuery, searchType, blockId, blockEndTime
 * @returns {String} hash
 *
 * @example: '&date=1997-11-04&view=day'
 */

export function getHash({
  date = null,
  view = null,
  searchQuery = null,
  searchType = null,
  blockId = null,
  blockEndTime = null
}) {
  const hashData = localStorage.getItem("hashData")
    ? JSON.parse(localStorage.getItem("hashData"))
    : null;
  date ??= hashData.date;
  view ??= hashData.view;
  searchQuery ??= hashData.searchQuery;
  searchType ??= hashData.searchType;
  blockId ??= hashData.blockId;
  blockEndTime ??= hashData.blockEndTime;

  let hash = "";
  if (date) {
    hash += `&date=${date}&view=${view}`;
  }
  if (searchQuery) {
    hash += `&searchQuery=${searchQuery}&searchType=${searchType}`;
  }
  if (blockId && !blockEndTime) {
    hash += `&blockId=${blockId}`;
  }
  if (blockId && blockEndTime) {
    hash += `&blockId=${blockId}&blockEndTime=${blockEndTime}`;
  }
  return hash;
}
